import dataAnalytics from '../../styles/assets/megaMenu/dataAnalytics.svg'
import earnedMedia from '../../styles/assets/megaMenu/earnedMedia.svg'
import paidMedia from '../../styles/assets/megaMenu/paidMedia.svg'
import creative from '../../styles/assets/megaMenu/creative.svg'
import technology from '../../styles/assets/megaMenu/technology.svg'
import { MIXPANEL_PROPS } from '../../utils/mixpanel'
import { getLanguageCode } from '../../utils/translation'

const getUrl = ({
  baseUrl = 'https://advanced.npdigital.com',
  path = 'consulting-page-with-utms',
  term,
  params = {},
}) => {
  const url = new URL(path, baseUrl)
  const searchParams = new URLSearchParams({
    utm_medium: 'ref',
    utm_source: 'uber',
    utm_campaign: 'us-mkt-campaigns-mql-tool-ubersuggest-mega-menu-links',
    utm_content: 'mega-menu',
    utm_term: term,
    ...params,
  })

  return `${url}?${searchParams}`
}

const getLanguageForUBS = () => {
  if (getLanguageCode() === 'en') return ''
  if (getLanguageCode() === 'pt') return 'br'
  return getLanguageCode()
}

export const menuItems = [
  {
    key: 'dataAnalytics',
    label: 'data_analytics',
    icon: dataAnalytics,
  },
  {
    key: 'earnedMedia',
    label: 'earned_media',
    icon: earnedMedia,
  },
  {
    key: 'paidMedia',
    label: 'paid_media',
    icon: paidMedia,
  },
  {
    key: 'creative',
    label: 'creative_area',
    icon: creative,
  },
  {
    key: 'technology',
    label: 'tech',
    icon: technology,
  },
]

const dataAnalyticsItems = {
  links: [
    {
      title: 'data_analytics_insights',
      description: 'data_analytics_insights_subheading',
      href: getUrl({ term: 'data-analytics-data-analytics' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'data_analytics_insights',
    },
    {
      title: 'user_experience',
      description: 'user_experience_subheading',
      href: getUrl({ term: 'data-analytics-user-experience' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'user_experience',
    },
    {
      title: 'dashboard_development',
      description: 'dashboard_development_subheading',
      href: getUrl({ term: 'data-analytics-dashboard-development' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'dashboard_development',
    },
    {
      title: 'conversion_rate_optimization',
      description: 'conversion_rate_optimization_subheading',
      href: getUrl({ term: 'data-analytics-conversion-rate' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'conversion_rate_optimization',
    },
    {
      title: 'ad_operations',
      description: 'ad_operations_subheading',
      href: getUrl({ term: 'data-analytics-ad-oprations' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'ad_operations',
    },
    {
      title: 'front_end_development',
      description: 'front_end_development_subheading',
      href: getUrl({ term: 'data-analytics-front-end-development' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
      mixPanelButtonLocation: 'front_end_development',
    },
  ],
  card: {
    title: 'data_analytics_cta_heading',
    description: 'data_analytics_cta_subheading',
    href: getUrl({ term: 'data-analytics-book-a-call-button' }),
    mixPanelMenuSubItemName:
      MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.DATA_ANALYTICS,
    mixPanelButtonLocation: 'book_a_call_button',
  },
}

const earnedMediaItems = {
  links: [
    {
      title: 'search_engine_optimization',
      description: 'search_engine_optimization_subheading',
      href: getUrl({ term: 'earned-media-search-engine-rewind' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'search_engine_optimization',
    },
    {
      title: 'content_marketing',
      description: 'content_marketing_subheading',
      href: getUrl({ term: 'earned-media-content-marketing' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'content_marketing',
    },
    {
      title: 'app_store_optimization',
      description: 'app_store_optimization_subheading',
      href: getUrl({ term: 'earned-media-app-store-optimization' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'app_store_optimization',
    },
    {
      title: 'influencer_marketing',
      description: 'influencer_marketing_subheading',
      href: getUrl({ term: 'earned-media-influencer-marketing' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'influencer_marketing',
    },
    {
      title: 'digital_pr',
      description: 'digital_pr_subheading',
      href: getUrl({ term: 'earned-media-digital-pr' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'digital_pr',
    },
    {
      title: 'organic_social_media',
      description: 'organic_social_media_subheading',
      href: getUrl({ term: 'earned-media-organic-social-media' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'organic_social_media',
    },
    {
      title: 'email_marketing',
      description: 'email_marketing_subheading',
      href: getUrl({ term: 'earned-media-email-marketing' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
      mixPanelButtonLocation: 'email_marketing',
    },
  ],
  card: {
    title: 'earned_media_cta_heading',
    description: 'earned_media_cta_subheading',
    href: getUrl({ term: 'earned-media-book-a-call-button' }),
    mixPanelMenuSubItemName:
      MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.EARNED_MEDIA,
    mixPanelButtonLocation: 'book_a_call_button',
  },
}

const paidMediaItems = {
  links: [
    {
      title: 'media_strategy',
      description: 'media_strategy_subheading',
      href: getUrl({ term: 'paid-media-media-strategy-planning' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'media_strategy_planning',
    },
    {
      title: 'programmatic',
      description: 'programmatic_subheading',
      href: getUrl({ term: 'paid-media-programmatic-display' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'programmatic_display',
    },
    {
      title: 'streaming',
      description: 'streaming_subheading',
      href: getUrl({ term: 'paid-media-streaming' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'streaming',
    },
    {
      title: 'paid_search',
      description: 'paid_search_subheading',
      href: getUrl({ term: 'paid-media-paid-search' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'paid_search',
    },
    {
      title: 'marketplaces',
      description: 'marketplaces_subheading',
      href: getUrl({ term: 'paid-media-marketplaces' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'marketplaces',
    },
    {
      title: 'paid_social',
      description: 'paid_social_subheading',
      href: getUrl({ term: 'paid-media-paid-social' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'paid_social',
    },
    {
      title: 'performance_creative',
      description: 'performance_creative_subheading',
      href: getUrl({ term: 'paid-media-perfomance-creative' }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
      mixPanelButtonLocation: 'perfomance_creative',
    },
  ],
  card: {
    title: 'paid_media_cta_heading',
    description: 'paid_media_cta_subheading_lb',
    href: getUrl({ term: 'paid-media-book-a-call-button' }),
    mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.PAID_MEDIA,
    mixPanelButtonLocation: 'book_a_call_button',
  },
}

const creativeItems = {
  links: [
    {
      title: 'creative_strategy',
      description: 'creative_strategy_subheading',
      href: getUrl({ term: 'creative-creative-strategy' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'creative_strategy',
    },
    {
      title: 'branding',
      description: 'branding_subheading',
      href: getUrl({ term: 'creative-branding' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'branding',
    },
    {
      title: 'content_production',
      description: 'content_production_subheading',
      href: getUrl({ term: 'creative-content-production' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'content_production',
    },
    {
      title: 'website_design',
      description: 'website_design_subheading',
      href: getUrl({ term: 'creative-website-design' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'website_design',
    },
    {
      title: 'graphic_motion_design',
      description: 'graphic_motion_design_subheading',
      href: getUrl({ term: 'creative-graphic-motion-design' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'graphic_motion_design',
    },
    {
      title: 'audio_production',
      description: 'audio_production_subheading',
      href: getUrl({ term: 'creative-audio-production' }),
      mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
      mixPanelButtonLocation: 'audio_production',
    },
  ],
  card: {
    title: 'creative_area_cta_heading',
    description: 'creative_area_cta_subheading',
    href: getUrl({ term: 'creative-book-a-call-button' }),
    mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.CREATIVE,
    mixPanelButtonLocation: 'book_a_call_button',
  },
}

const technologyItems = {
  links: [
    {
      title: 'answer_the_public',
      description: 'answer_the_public_subheading',
      href: getUrl({
        baseUrl: 'https://answerthepublic.com',
        path: ['en', 'zh', 'nl'].includes(getLanguageCode())
          ? ''
          : getLanguageCode(),
        term: 'technology-answer-the-public',
      }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.TECHNOLOGY,
      mixPanelButtonLocation: 'answer_the_public',
    },
    {
      title: 'ubersuggest',
      description: 'ubersuggest_subheading',
      href: getUrl({
        baseUrl: 'https://neilpatel.com',
        path: `${getLanguageForUBS()}/ubersuggest`,
        term: 'technology-ubersuggest',
      }),
      mixPanelMenuSubItemName:
        MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.TECHNOLOGY,
      mixPanelButtonLocation: 'ubersuggest',
    },
  ],
  card: {
    title: 'tech_cta_heading',
    description: 'tech_cta_subheading',
    href: getUrl({ term: 'technology-book-a-call-button' }),
    mixPanelMenuSubItemName: MIXPANEL_PROPS.MENU_SUBITEM_NAME.values.TECHNOLOGY,
    mixPanelButtonLocation: 'book_a_call_button',
  },
}

export const allItems = {
  dataAnalytics: { ...dataAnalyticsItems },
  earnedMedia: { ...earnedMediaItems },
  paidMedia: { ...paidMediaItems },
  creative: { ...creativeItems },
  technology: { ...technologyItems },
}
